import * as shared from '@aloft/toolkit-shared';
import { expected } from '@aloft/toolkit-shared';
import { Flex } from '@aloft/toolkit-sui';

import { Outlet, useParams } from 'react-router';

import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary.js';
import { ToolkitGenericFallback } from '../../components/ToolkitGenericFallback.js';
import { MainLayout } from '../../layout/MainLayout.js';
import { logger } from '../../logging/logging.js';
import { Tkv2ReferenceViewDrawer } from '../../modules/referenceView/Tkv2ReferenceViewDrawer.js';
import { Tkv2ControllerReferenceBarContext } from '../Tkv2ControllerReferenceBarContext.js';
import { Tkv2OrderContext } from '../Tkv2OrderContext.js';
import { useTriggeredAlertToasts } from '../../hooks/useTriggeredAlertToasts.ts';
import { useNewTkv2OrderContext } from '../hooks/useNewTkv2OrderContext.js';
import { useNewTkv2ReferenceBarUserInterface } from '../hooks/useNewTkv2ReferenceBarUserInterface.js';
import { useTkv2OrderContext } from '../hooks/useTkv2ControllerOrder.js';

const log = logger();

export function Tkv2OrderRootRouteElement() {
  const { orderId } = useParams();
  const ctx = useNewTkv2OrderContext(expected(orderId));
  const referenceBarUI = useNewTkv2ReferenceBarUserInterface();

  if (ctx === null) {
    return null;
  }

  (window as any).ctx = ctx;
  (window as any).shared = shared;

  return (
    <Tkv2OrderContext.Provider value={ctx}>
      <Tkv2ControllerReferenceBarContext.Provider value={referenceBarUI}>
        <Root />
      </Tkv2ControllerReferenceBarContext.Provider>
    </Tkv2OrderContext.Provider>
  );
}

function Root() {
  const ctx = useTkv2OrderContext();
  const { subject } = ctx;
  useTriggeredAlertToasts();

  return (
    <MainLayout
      title={
        shared.orUndefined(shared.addressToString)(subject?.body.getStructuredData('address')) ?? ''
      }
      showNav={false}
    >
      <Flex height="100%" width="100%">
        <ErrorBoundary
          Fallback={ToolkitGenericFallback}
          onError={() => log.fatal(ctx, 'ToolkitControllerOrderGlobal ctx dump')}
        >
          <Tkv2ReferenceViewDrawer>
            <Outlet />
          </Tkv2ReferenceViewDrawer>
        </ErrorBoundary>
      </Flex>
    </MainLayout>
  );
}
